import React from "react";
import SectionHeader from "../../orders/single-view/parts/SectionHeader";

const SectionView = ({
	title,
	canEdit = false,
	handleEdit = () => {},
	children,
	wrapperClasses = "pl-48 pr-24",
	"data-testid": dataTestId,
	editButtonTestId = "section-view-edit-button",
	...props
}) => {
	return (
		<div className={`mt-48 ${wrapperClasses}`} data-testid={dataTestId}>
			<SectionHeader
				title={title}
				wrapperClasses="py-regular border-b-1 border-n150"
				isEdit={canEdit}
				handleEdit={handleEdit}
				editButtonTestId={editButtonTestId}
			/>
			{children}
		</div>
	);
};

export default SectionView;
